import React from 'react'
import { colors } from 'shared/assets/styles'
import { InfoKeepCard } from '../components/InfoKeepCard'
import { useIntl } from 'react-intl'
import { Redirect, useParams } from 'react-router-dom'
import type { TPKState } from 'shared/store/tu-preferes-king/types'
import { useTPKState } from 'shared/store/tu-preferes-king'
import { Text } from '../../common/typography'
import { TPKLayout } from '../components/TPKLayout'
import { Winnings } from './Winnings'
import { InfoGoodies } from './components/info-goodies/InfoGoodies'

export function TuPreferesKingDuel() {
    const { tpkToken } = useParams()
    const intl = useIntl()

    const data: TPKState = useTPKState(tpkToken, {
        autoload: true
    })

    if (
        data.duel &&
        (data.duel.childGain.selected || data.duel.parentGain.selected)
    ) {
        return (
            <Redirect
                to={intl.formatMessage(
                    { id: 'routes.tupreferesking.duel.win.tpkToken' },
                    {
                        tpkToken
                    }
                )}
            />
        )
    }
    const duel = data.duel
    return (
        <TPKLayout
            header={{
                title: intl.formatMessage({
                    id: 'tupreferesking.duel.title'
                }),
                subTitle: intl.formatMessage({
                    id: 'tupreferesking.duel.sub-title'
                })
            }}>
            {data.error && (
                <Text color={colors.fieryRed}>
                    {intl.formatMessage({
                        id: `tupreferesking.errors.${data.error}`
                    })}
                </Text>
            )}

            <Winnings
                child={duel && duel.childGain}
                parent={duel && duel.parentGain}
            />

            {duel && (
                <InfoGoodies
                    parentGain={duel.parentGain}
                    childGain={duel.childGain}
                />
            )}

            <InfoKeepCard />
        </TPKLayout>
    )
}
